import { App } from 'vue';
import '@/project/form/zodValidation.plugin';
import '@/project/config/responsive-image.config';
import projectComponentRegistrations from '@/project/config/projectComponentRegistrations';
import clickOutside from '@/project/config/v-click-outside.plugin';
import formItems from '@/project/form';
import ourApp from '@/project/app';
import tooltip from '@/project/config/v-tooltip.plugin';
import datePicker from '@/project/ui-components/date-picker/date-picker.plugin';
import filters from '@/project/filters';
import '@/project/basket';
import auth from '@/project/auth/';
import gtm from '@/project/tracking/gtm';
import '@/project/app/blocks/google-maps/GoogleMaps.plugin';

export default function config(app: App) {
    projectComponentRegistrations(app);
    clickOutside(app);
    formItems(app);
    tooltip(app);
    datePicker(app);
    ourApp(app);
    filters(app);
    auth(app);
    gtm(app);
}
